// extracted by mini-css-extract-plugin
export var container = "_ob-0";
export var dotAnimation = "_ob-2";
export var dotsLoading = "_ob-1";